(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["animate-in"] && !Shopify.designMode) return;
  try {
    (function () {
    if (window.Shopify && window.Shopify.designMode) return;
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    if (window._animateInInitialized) return;
    window._animateInInitialized = true;

    function reveal(el) {
      el.classList.add('animate-visible');
    }

    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        observer.unobserve(entry.target);

        if (entry.target.hasAttribute('data-animate-children')) {
          var container = entry.target;
          var children = container.children;
          var len = children.length;
          var toPassthrough = [];

          for (var i = 0; i < len; i++) {
            var nested = children[i].querySelector('[data-animate-children]');
            if (nested) {
              toPassthrough.push({ wrapper: children[i], container: nested });
            }
          }

          requestAnimationFrame(function () {
            requestAnimationFrame(function () {
              for (var j = 0; j < toPassthrough.length; j++) {
                toPassthrough[j].wrapper.style.transition = 'none';
                reveal(toPassthrough[j].wrapper);
                void toPassthrough[j].wrapper.offsetHeight;
                toPassthrough[j].wrapper.style.transition = '';
              }
              for (var i = 0; i < len; i++) {
                childObserver.observe(children[i]);
              }
              for (var j = 0; j < toPassthrough.length; j++) {
                observer.observe(toPassthrough[j].container);
              }
            });
          });
        } else {
          reveal(entry.target);
        }
      });
    }, { threshold: 0, rootMargin: '0px 0px 0px 0px' });

    var childObserver = new IntersectionObserver(function (entries) {
      var visible = [];
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        childObserver.unobserve(entry.target);
        visible.push(entry.target);
      });
      for (var i = 0; i < visible.length; i++) {
        visible[i].style.setProperty('--anim-delay', (i * 0.08) + 's');
        reveal(visible[i]);
      }
    }, { threshold: 0.1, rootMargin: '0px 0px -20px 0px' });

    function initAnimateIn(root) {
      var scope = root || document;
      requestAnimationFrame(function () {
        requestAnimationFrame(function () {
          var elements = scope.querySelectorAll('[data-animate]:not(.animate-visible)');
          for (var i = 0; i < elements.length; i++) {
            observer.observe(elements[i]);
          }
          var containers = scope.querySelectorAll('[data-animate-children]');
          for (var j = 0; j < containers.length; j++) {
            var parent = containers[j].parentElement;
            if (parent && parent.closest('[data-animate-children]')) continue;
            observer.observe(containers[j]);
          }
        });
      });
    }

    window.initAnimateIn = initAnimateIn;

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () { initAnimateIn(); });
    } else {
      initAnimateIn();
    }
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["cart-drawer"] && !Shopify.designMode) return;
  try {
    class CartDrawer extends HTMLElement {
    constructor() {
      super();
      this.drawer = this;
      this.overlay = this.querySelector('.cart-drawer__overlay');
      this.closeBtn = this.querySelector('.cart-drawer__close');
      this.itemsContainer = this.querySelector('.cart-drawer__items');
      this.footer = this.querySelector('.cart-drawer__footer');
      this.inner = this.querySelector('.cart-drawer__inner');

      if (this.closeBtn) {
        this.closeBtn.addEventListener('click', () => this.close());
      }
      if (this.overlay) {
        this.overlay.addEventListener('click', () => this.close());
      }
      
      document.addEventListener('keydown', (e) => {
        if (e.key === 'Escape' && this.drawer.classList.contains('is-open')) {
          this.close();
        }
      });

      if (this.inner) {
        this.inner.addEventListener('click', (e) => this.handleItemClick(e));
        this.inner.addEventListener('change', (e) => this.handleItemChange(e));
      }

      this.addEventListener('click', (e) => {
        const quickAddBtn = e.target.closest('[data-quick-add]');
        if (quickAddBtn) {
          e.preventDefault();
          e.stopPropagation();
          const formData = new FormData();
          formData.append('id', quickAddBtn.dataset.quickAdd);
          formData.append('quantity', 1);
          window.CartUtils.addItem(formData);
        }
      });
    }

    connectedCallback() {
      window.subscribe('cart:updated', (data) => {
        this.refresh();
        if (data && data.product) {
          this.open();
        }
      });

      if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', () => this.setupCartIcon());
      } else {
        this.setupCartIcon();
      }

      this.initDragScroll();
    }

    setupCartIcon() {
      const cartLink = document.getElementById('cart-icon-bubble');
      if (!cartLink) return;

      cartLink.addEventListener('click', (e) => {
        e.preventDefault();
        this.open();
      });
    }

    open() {
      this.drawer.classList.add('is-open');
      document.body.style.overflow = 'hidden';
      this.previousFocus = document.activeElement;
      this.trapFocus();
      this.closeBtn?.focus();
      this.fetchRecommendations();
    }

    close() {
      this.drawer.classList.remove('is-open');
      document.body.style.overflow = '';
      this.releaseFocus();
      if (this.previousFocus) {
        this.previousFocus.focus();
      }
    }

    trapFocus() {
      const content = this.querySelector('.cart-drawer__content');
      if (!content) return;
      
      const focusableElements = content.querySelectorAll(
        'button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])'
      );
      
      if (focusableElements.length === 0) return;
      
      const firstElement = focusableElements[0];
      const lastElement = focusableElements[focusableElements.length - 1];
      
      this.focusTrapHandler = (e) => {
        if (e.key !== 'Tab') return;
        
        if (e.shiftKey) {
          if (document.activeElement === firstElement) {
            e.preventDefault();
            lastElement.focus();
          }
        } else {
          if (document.activeElement === lastElement) {
            e.preventDefault();
            firstElement.focus();
          }
        }
      };
      
      content.addEventListener('keydown', this.focusTrapHandler);
    }

    releaseFocus() {
      const content = this.querySelector('.cart-drawer__content');
      if (content && this.focusTrapHandler) {
        content.removeEventListener('keydown', this.focusTrapHandler);
        this.focusTrapHandler = null;
      }
    }

    handleItemClick(e) {
      const minusBtn = e.target.closest('[data-qty-minus]');
      const plusBtn = e.target.closest('[data-qty-plus]');
      const quickAddBtn = e.target.closest('[data-quick-add]');

      if (minusBtn) {
        const item = minusBtn.closest('.cart-drawer__item');
        const input = item.querySelector('[data-qty-input]');
        const newQty = parseInt(input.value) - 1;
        if (newQty >= 0) {
          this.updateItem(item.dataset.itemKey, newQty);
        }
      } else if (plusBtn) {
        const item = plusBtn.closest('.cart-drawer__item');
        const input = item.querySelector('[data-qty-input]');
        const newQty = parseInt(input.value) + 1;
        this.updateItem(item.dataset.itemKey, newQty);
      } else if (quickAddBtn) {
        e.preventDefault();
        const variantId = quickAddBtn.dataset.quickAdd;
        const formData = new FormData();
        formData.append('id', variantId);
        formData.append('quantity', 1);
        window.CartUtils.addItem(formData);
      }
    }

    handleItemChange(e) {
      if (e.target.matches('[data-qty-input]')) {
        const item = e.target.closest('.cart-drawer__item');
        const newQty = parseInt(e.target.value);
        if (newQty >= 0) {
          this.updateItem(item.dataset.itemKey, newQty);
        }
      } else if (e.target.matches('.cart-drawer__note-input')) {
        this.updateNote(e.target.value);
      }
    }

    async updateItem(key, quantity) {
      try {
        const response = await fetch('/cart/change.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({ id: key, quantity }),
        });

        const cart = await response.json();
        this.refresh();

        window.publish('cart:item-updated', { cart });
      } catch (error) {
        console.error('Error updating cart:', error);
      }
    }

    async updateNote(note) {
      try {
        await fetch('/cart/update.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({ note }),
        });
      } catch (error) {
        console.error('Error updating note:', error);
      }
    }

    async refresh() {
      const wasOpen = this.drawer.classList.contains('is-open');
      if (wasOpen) {
        this.releaseFocus();
      }
      
      try {
        const response = await fetch('/cart?section_id=cart-drawer');
        const html = await response.text();
        const parser = new DOMParser();
        const doc = parser.parseFromString(html, 'text/html');

        const newItems = doc.querySelector('.cart-drawer__items');
        const newFooter = doc.querySelector('.cart-drawer__footer');
        const newInner = doc.querySelector('.cart-drawer__inner');
        const newCount = doc.querySelector('.cart-drawer__count');

        if (newInner && this.inner) {
          this.inner.innerHTML = newInner.innerHTML;
        }

        if (newFooter && this.footer) {
          this.footer.innerHTML = newFooter.innerHTML;
        }

        if (newCount) {
          const countEl = this.querySelector('.cart-drawer__count');
          if (countEl) countEl.textContent = newCount.textContent;
        }

        if (newInner && newInner.querySelector('.cart-drawer__empty')) {
          this.drawer.classList.add('is-empty');
        } else {
          this.drawer.classList.remove('is-empty');
        }

        this.itemsContainer = this.querySelector('.cart-drawer__items');
        this.updateCartBubble();
        this.fetchRecommendations();
        
        if (wasOpen) {
          this.trapFocus();
        }
      } catch (error) {
        console.error('Error refreshing cart drawer:', error);
      }
    }

    async fetchRecommendations() {
      const container = this.querySelector('[data-cart-recommendations]');
      if (!container) return;

      const url = container.dataset.url;
      if (!url) return;

      const list = container.querySelector('.cart-drawer__recommendations-list');
      if (!list) return;

      try {
        const response = await fetch(url);
        const html = await response.text();
        const parser = new DOMParser();
        const doc = parser.parseFromString(html, 'text/html');
        const content = doc.querySelector('[data-recommendations-content]');
        if (content) {
          list.innerHTML = content.innerHTML;
          container.style.display = '';
        }
      } catch (error) {
        console.error('Error fetching recommendations:', error);
      }
    }

    initDragScroll() {
      const setup = (list) => {
        if (!list || list.hasAttribute('data-drag-bound')) return;
        list.setAttribute('data-drag-bound', 'true');

        let startX, scrollLeft, isDragging, hasMoved;

        list.addEventListener('mousedown', (e) => {
          e.preventDefault();
          isDragging = true;
          hasMoved = false;
          startX = e.pageX;
          scrollLeft = list.scrollLeft;
          list.style.scrollSnapType = 'none';
        });

        const stopDrag = () => {
          if (!isDragging) return;
          isDragging = false;
          list.style.scrollSnapType = '';
          if (hasMoved) {
            setTimeout(() => { hasMoved = false; }, 0);
          }
        };

        list.addEventListener('mouseleave', stopDrag);
        list.addEventListener('mouseup', stopDrag);
        list.addEventListener('mousemove', (e) => {
          if (!isDragging) return;
          const dx = e.pageX - startX;
          if (Math.abs(dx) > 3) {
            hasMoved = true;
            e.preventDefault();
          }
          if (hasMoved) {
            list.scrollLeft = scrollLeft - dx;
          }
        });

        list.addEventListener('click', (e) => {
          if (hasMoved) {
            e.preventDefault();
            e.stopPropagation();
            hasMoved = false;
          }
        }, true);
      };

      setup(this.querySelector('.cart-drawer__recommendations-list'));
      new MutationObserver(() => {
        setup(this.querySelector('.cart-drawer__recommendations-list'));
      }).observe(this, { childList: true, subtree: true });
    }

    async updateCartBubble() {
      try {
        const response = await fetch('/cart?section_id=cart-icon-bubble');
        const html = await response.text();
        const parser = new DOMParser();
        const doc = parser.parseFromString(html, 'text/html');
        const newBubble = doc.getElementById('cart-icon-bubble');
        const cartBubble = document.getElementById('cart-icon-bubble');
        if (newBubble && cartBubble) {
          cartBubble.outerHTML = newBubble.outerHTML;
          this.setupCartIcon();
        }
      } catch (error) {
        console.error('Error updating cart bubble:', error);
      }
    }
  }

  customElements.define('cart-drawer', CartDrawer);
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["cart-notification"] && !Shopify.designMode) return;
  try {
    class CartNotification extends HTMLElement {
    constructor() {
      super();
      this.notification = document.getElementById('cart-notification');
      this.overlay = document.getElementById('cart-notification-overlay');
      this.productContainer = document.getElementById('cart-notification-product');
      this.countElement = document.getElementById('cart-notification-count');
      this.closeButton = this.notification.querySelector('.cart-notification__close');
      
      this.closeButton.addEventListener('click', () => this.close());
      this.overlay.addEventListener('click', () => this.close());
    }

    connectedCallback() {
      window.subscribe('cart:updated', (data) => {
        if (data && data.product) {
          this.showProduct(data.product, data.cart);
        }
      });
    }

    showProduct(product, cart) {
      const imageAlt = (product.image && product.image.alt) || product.title || '';
      
      this.productContainer.innerHTML = `
        <div class="cart-notification__product-image-wrapper">
          <img
            src="${product.image || ''}"
            alt="${imageAlt}"
            class="cart-notification__product-image"
            width="60"
            height="60"
          >
        </div>
        <div class="cart-notification__product-details">
          <h3 class="cart-notification__product-name">${product.title || ''}</h3>
          <p class="cart-notification__product-meta">
            ${product.quantity > 1 ? `Qty: ${product.quantity}` : ''}
            ${product.variant_title && product.variant_title !== 'Default Title' ? product.variant_title : ''}
          </p>
        </div>
      `;

      if (cart && cart.item_count !== undefined) {
        const itemText = cart.item_count === 1 ? 'item' : 'items';
        this.countElement.textContent = `(${cart.item_count} ${itemText})`;
      }

      this.open();
    }

    open() {
      this.notification.hidden = false;
      this.overlay.hidden = false;
    }

    close() {
      this.notification.hidden = true;
      this.overlay.hidden = true;
    }
  }

  customElements.define('cart-notification', CartNotification);
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["product-card"] && !Shopify.designMode) return;
  try {
    document.querySelectorAll('.product-card__form').forEach(form => {
    form.addEventListener('submit', async (e) => {
      e.preventDefault();
      
      const button = form.querySelector('[data-add-to-cart]');
      const formData = new FormData(form);
      const cartType = window.CartUtils ? window.CartUtils.getCartType() : 'page';
      
      button.classList.add('is-adding');
      button.disabled = true;
      
      try {
        const result = await window.CartUtils.addItem(formData);
        
        if (result.success) {
          button.classList.remove('is-adding');
          button.classList.add('is-added');
          
          if (cartType === 'page') {
            window.location = '/cart';
          }
          
          setTimeout(() => {
            button.classList.remove('is-added');
            button.disabled = false;
          }, 2000);
        } else {
          throw new Error(result.error || 'Failed to add to cart');
        }
      } catch (error) {
        console.error('Error adding to cart:', error);
        button.classList.remove('is-adding');
        button.disabled = false;
      }
    });
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["product-gallery"] && !Shopify.designMode) return;
  try {
    (function() {
    function initProductGalleries() {
      document.querySelectorAll('[data-product-gallery]').forEach(gallery => {
        if (gallery.dataset.initialized) return;
        gallery.dataset.initialized = 'true';

        const enableZoom = gallery.dataset.enableZoom === 'true';
        const mainImage = gallery.querySelector('[data-current-image]');
        const mainImageContainer = gallery.querySelector('.product-gallery__main-image');
        const thumbnails = gallery.querySelectorAll('[data-thumbnail-url]');
        const prevBtn = gallery.querySelector('[data-carousel-prev]');
        const nextBtn = gallery.querySelector('[data-carousel-next]');
        const dots = gallery.querySelectorAll('[data-carousel-dot]');

        if (!mainImage) return;

        // Store all images for carousel navigation
        const images = [];
        let currentIndex = 0;

        // Build images array from thumbnails or dots (for carousel mode)
        if (thumbnails.length > 0) {
          thumbnails.forEach(thumb => {
            images.push({
              url: thumb.dataset.thumbnailUrl,
              srcset: thumb.dataset.thumbnailSrcset,
              alt: thumb.dataset.thumbnailAlt,
              id: thumb.dataset.thumbnailId
            });
          });
        } else if (dots.length > 0) {
          dots.forEach(dot => {
            images.push({
              url: dot.dataset.imageUrl,
              srcset: dot.dataset.imageSrcset,
              alt: dot.dataset.imageAlt,
              id: dot.dataset.imageId
            });
          });
        }

        // Find current image index
        if (images.length > 0) {
          currentIndex = images.findIndex(img => img.id == mainImage.dataset.imageId);
          if (currentIndex === -1) currentIndex = 0;
        }

        // Function to update main image
        function updateImage(index) {
          if (index < 0 || index >= images.length) return;

          const imageData = images[index];
          mainImage.src = imageData.url;
          mainImage.srcset = imageData.srcset;
          mainImage.alt = imageData.alt || '';
          mainImage.dataset.imageId = imageData.id;

          // Update thumbnails active state
          thumbnails.forEach(thumb => {
            thumb.classList.remove('product-gallery__thumbnail--active');
            if (thumb.dataset.thumbnailId == imageData.id) {
              thumb.classList.add('product-gallery__thumbnail--active');
            }
          });

          // Update dots active state
          dots.forEach(dot => {
            dot.classList.remove('product-gallery__dot--active');
            if (dot.dataset.imageId == imageData.id) {
              dot.classList.add('product-gallery__dot--active');
            }
          });

          currentIndex = index;

          // Reset zoom state
          if (enableZoom) {
            mainImage.classList.remove('product-gallery__image--zoomed');
          }
        }

        // Thumbnail click handler
        thumbnails.forEach((thumb, index) => {
          thumb.addEventListener('click', function(e) {
            e.preventDefault();
            updateImage(index);
          });
        });

        // Carousel navigation
        if (prevBtn && nextBtn && images.length > 1) {
          prevBtn.addEventListener('click', function() {
            let newIndex = currentIndex - 1;
            if (newIndex < 0) newIndex = images.length - 1;
            updateImage(newIndex);
          });

          nextBtn.addEventListener('click', function() {
            let newIndex = currentIndex + 1;
            if (newIndex >= images.length) newIndex = 0;
            updateImage(newIndex);
          });
        }

        // Dot navigation
        dots.forEach((dot, index) => {
          dot.addEventListener('click', function() {
            updateImage(index);
          });
        });

        // Zoom functionality
        if (enableZoom && mainImage.classList.contains('product-gallery__image--zoomable')) {
          let isZoomed = false;

          const handleZoomStart = function(e) {
            if (e.target.closest('.product-gallery__award')) return;
            isZoomed = !isZoomed;
            mainImage.classList.toggle('product-gallery__image--zoomed', isZoomed);
          };

          const handleZoomMove = function(e) {
            if (!isZoomed) return;

            const rect = mainImage.getBoundingClientRect();
            const x = e.clientX - rect.left;
            const y = e.clientY - rect.top;

            mainImage.style.transformOrigin = `${x}px ${y}px`;
          };

          const handleZoomEnd = function() {
            isZoomed = false;
            mainImage.classList.remove('product-gallery__image--zoomed');
            mainImage.style.transformOrigin = 'center center';
          };

          // Mouse events
          mainImage.addEventListener('click', handleZoomStart);
          mainImage.addEventListener('mousemove', handleZoomMove);
          mainImage.addEventListener('mouseleave', handleZoomEnd);

          // Touch events for mobile
          let touchStartX, touchStartY;
          mainImage.addEventListener('touchstart', function(e) {
            if (e.touches.length === 1) {
              touchStartX = e.touches[0].clientX;
              touchStartY = e.touches[0].clientY;
            }
          });

          mainImage.addEventListener('touchend', function(e) {
            if (e.changedTouches.length === 1) {
              const touchEndX = e.changedTouches[0].clientX;
              const touchEndY = e.changedTouches[0].clientY;
              const diffX = Math.abs(touchEndX - touchStartX);
              const diffY = Math.abs(touchEndY - touchStartY);

              if (diffX < 10 && diffY < 10) {
                handleZoomStart(e);
              }
            }
          });
        }
      });
    }

    // Listen for variant changes
    document.addEventListener('variant:change', function(e) {
      const variant = e.detail.variant;
      if (!variant || !variant.featured_image) return;

      const gallery = document.querySelector('[data-product-gallery]');
      if (!gallery) return;

      const mainImage = gallery.querySelector('[data-current-image]');
      const thumbnails = gallery.querySelectorAll('[data-thumbnail-url]');
      const dots = gallery.querySelectorAll('[data-carousel-dot]');

      if (mainImage) {
        const featuredImage = variant.featured_image;
        const newSrc = featuredImage.url;
        const newAlt = featuredImage.alt || '';

        mainImage.src = newSrc;
        mainImage.alt = newAlt;
        mainImage.dataset.imageId = featuredImage.id;

        // Update thumbnail active state
        thumbnails.forEach(thumb => {
          thumb.classList.remove('product-gallery__thumbnail--active');
          if (thumb.dataset.thumbnailId == featuredImage.id) {
            thumb.classList.add('product-gallery__thumbnail--active');
          }
        });

        // Update dots active state
        dots.forEach(dot => {
          dot.classList.remove('product-gallery__dot--active');
          if (dot.dataset.imageId == featuredImage.id) {
            dot.classList.add('product-gallery__dot--active');
          }
        });
      }
    });

    // Initialize galleries
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initProductGalleries);
    } else {
      initProductGalleries();
    }
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["product-quantity"] && !Shopify.designMode) return;
  try {
    class QuantitySelector {
    constructor(container) {
      this.container = container
      this.input = container.querySelector('[data-quantity-input]')
      this.minusBtn = container.querySelector('[data-quantity-minus]')
      this.plusBtn = container.querySelector('[data-quantity-plus]')
      
      this.min = parseInt(this.input.min, 10) || 1
      this.max = parseInt(this.input.max, 10) || 99
      
      this.init()
    }

    init() {
      this.minusBtn.addEventListener('click', () => this.decrease())
      this.plusBtn.addEventListener('click', () => this.increase())
      this.input.addEventListener('change', () => this.validate())
      
      this.updateButtons()
    }

    decrease() {
      const current = parseInt(this.input.value, 10)
      if (current > this.min) {
        this.input.value = current - 1
        this.triggerChange()
      }
    }

    increase() {
      const current = parseInt(this.input.value, 10)
      if (current < this.max) {
        this.input.value = current + 1
        this.triggerChange()
      }
    }

    validate() {
      let value = parseInt(this.input.value, 10)
      
      if (isNaN(value) || value < this.min) {
        value = this.min
      } else if (value > this.max) {
        value = this.max
      }
      
      this.input.value = value
      this.updateButtons()
    }

    updateButtons() {
      const current = parseInt(this.input.value, 10)
      this.minusBtn.disabled = current <= this.min
      this.plusBtn.disabled = current >= this.max
    }

    triggerChange() {
      this.input.dispatchEvent(new Event('change', { bubbles: true }))
      this.updateButtons()
    }
  }

  document.querySelectorAll('[data-quantity-selector]').forEach(selector => {
    new QuantitySelector(selector)
  })
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["product-tabs"] && !Shopify.designMode) return;
  try {
    class ProductTabs {
    constructor(container) {
      this.container = container
      this.layout = container.dataset.layout

      if (this.layout === 'tabs') {
        this.buttons = container.querySelectorAll('[data-tab-button]')
        this.panels = container.querySelectorAll('[data-tab-panel]')
        this.initTabs()
      } else {
        this.buttons = container.querySelectorAll('[data-accordion-button]')
        this.panels = container.querySelectorAll('[data-accordion-panel]')
        this.initAccordion()
      }
    }

    initTabs() {
      this.buttons.forEach(button => {
        button.addEventListener('click', () => this.switchTab(button))
      })
    }

    switchTab(activeButton) {
      const tabId = activeButton.dataset.tabButton

      this.buttons.forEach(button => {
        const isActive = button === activeButton
        button.classList.toggle('product-tabs__tab--active', isActive)
        button.setAttribute('aria-selected', isActive)
      })

      this.panels.forEach(panel => {
        const isActive = panel.dataset.tabPanel === tabId
        panel.classList.toggle('product-tabs__panel--active', isActive)
      })
    }

    initAccordion() {
      this.buttons.forEach(button => {
        button.addEventListener('click', () => this.toggleAccordion(button))
      })

      requestAnimationFrame(() => {
        const activePanel = this.container.querySelector('.product-tabs__accordion-content--active')
        if (activePanel) {
          activePanel.style.maxHeight = activePanel.scrollHeight + 'px'
        }
      })
    }

    toggleAccordion(button) {
      const isActive = button.classList.contains('product-tabs__accordion-header--active')
      const panelId = button.dataset.accordionButton
      const panel = this.container.querySelector(`[data-accordion-panel="${panelId}"]`)

      this.buttons.forEach(btn => {
        btn.classList.remove('product-tabs__accordion-header--active')
        btn.setAttribute('aria-expanded', 'false')
      })
      this.panels.forEach(pnl => {
        pnl.style.maxHeight = '0px'
      })

      if (!isActive) {
        button.classList.add('product-tabs__accordion-header--active')
        button.setAttribute('aria-expanded', 'true')
        requestAnimationFrame(() => {
          panel.style.maxHeight = panel.scrollHeight + 'px'
        })
      }
    }
  }

  document.querySelectorAll('[data-product-tabs]').forEach(tabs => {
    new ProductTabs(tabs)
  })
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["product-variant-picker"] && !Shopify.designMode) return;
  try {
    class VariantPicker {
    constructor(container) {
      this.container = container
      this.masterSelect = container.querySelector('[data-variant-master-select]')
      this.productData = JSON.parse(container.querySelector('[data-product-json]').textContent)
      this.colorLabel = container.querySelector('[data-color-label]')
      
      this.init()
    }

    init() {
      this.container.querySelectorAll('[data-variant-value]').forEach(button => {
        button.addEventListener('click', () => this.selectOption(button))
      })
      
      this.container.querySelectorAll('[data-option-select]').forEach(select => {
        select.addEventListener('change', (e) => this.selectDropdownOption(e.target))
      })
    }

    selectOption(button) {
      if (button.disabled) return
      
      const optionIndex = button.dataset.optionIndex
      const value = button.dataset.variantValue
      
      const buttons = this.container.querySelectorAll(`[data-option-index="${optionIndex}"]`)
      buttons.forEach(btn => {
        btn.classList.remove('product-variant-picker__button--selected', 'product-variant-picker__swatch--selected')
        btn.setAttribute('aria-pressed', 'false')
      })
      
      button.classList.add(button.classList.contains('product-variant-picker__swatch') ? 'product-variant-picker__swatch--selected' : 'product-variant-picker__button--selected')
      button.setAttribute('aria-pressed', 'true')
      
      if (this.colorLabel) {
        this.colorLabel.textContent = value
      }
      
      this.updateVariant()
    }

    selectDropdownOption(select) {
      this.updateVariant()
    }

    updateVariant() {
      const selectedOptions = []
      
      this.container.querySelectorAll('fieldset').forEach((fieldset, index) => {
        const selectedButton = fieldset.querySelector('.product-variant-picker__button--selected, .product-variant-picker__swatch--selected')
        const selectedSelect = fieldset.querySelector('select')
        
        if (selectedButton) {
          selectedOptions.push(selectedButton.dataset.variantValue)
        } else if (selectedSelect) {
          selectedOptions.push(selectedSelect.value)
        }
      })
      
      const variant = this.productData.variants.find(v => {
        return v.options.every((option, index) => option === selectedOptions[index])
      })
      
      if (variant) {
        this.masterSelect.value = variant.id
        this.masterSelect.dispatchEvent(new Event('change', { bubbles: true }))
        
        this.container.dispatchEvent(new CustomEvent('variant:change', {
          bubbles: true,
          detail: { variant }
        }))
      }
    }
  }

  document.querySelectorAll('[data-variant-picker]').forEach(picker => {
    new VariantPicker(picker)
  })
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["pseudo-variant-picker"] && !Shopify.designMode) return;
  try {
    class PseudoVariantSlider {
    constructor(el) {
      this.track = el.querySelector('[data-slider-track]')
      const option = el.closest('.pseudo-variant-picker__option')
      this.prevBtn = option.querySelector('[data-slider-prev]')
      this.nextBtn = option.querySelector('[data-slider-next]')
      if (!this.track || !this.prevBtn || !this.nextBtn) return

      this.prevBtn.addEventListener('click', () => this.scroll(-1))
      this.nextBtn.addEventListener('click', () => this.scroll(1))
      this.track.addEventListener('scroll', () => this.updateButtons())
      this.updateButtons()
    }

    scroll(dir) {
      const child = this.track.querySelector('.pseudo-variant-picker__button')
      if (!child) return
      const amount = child.offsetWidth + parseInt(getComputedStyle(this.track).gap) || 0
      this.track.scrollBy({ left: amount * dir, behavior: 'smooth' })
    }

    updateButtons() {
      const { scrollLeft, scrollWidth, clientWidth } = this.track
      this.prevBtn.disabled = scrollLeft <= 2
      this.nextBtn.disabled = scrollLeft + clientWidth >= scrollWidth - 2
    }
  }

  document.querySelectorAll('[data-slider]').forEach(el => new PseudoVariantSlider(el))
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["recipe-gallery"] && !Shopify.designMode) return;
  try {
    (function() {
    var header = document.querySelector('[data-header]');
    var recipe = document.querySelector('[data-recipe]');
    if (header && recipe) {
      function syncHeaderHeight() {
        recipe.style.setProperty('--header-height', header.offsetHeight + 'px');
      }
      syncHeaderHeight();
      if (typeof ResizeObserver !== 'undefined') {
        new ResizeObserver(syncHeaderHeight).observe(header);
      }
    }

    var gallery = document.querySelector('[data-recipe-gallery]');
    if (!gallery) return;

    var track = gallery.querySelector('[data-gallery-track]');
    var originals = gallery.querySelectorAll('[data-gallery-slide]:not([data-gallery-clone])');
    var prevBtn = gallery.querySelector('[data-gallery-prev]');
    var nextBtn = gallery.querySelector('[data-gallery-next]');
    var autoplay = gallery.dataset.autoplay === 'true';
    var enableZoom = gallery.dataset.zoom === 'true';
    var lightbox = document.querySelector('.recipe__lightbox');

    var count = originals.length;
    if (count === 0) return;

    var images = [];
    originals.forEach(function(slide) {
      var img = slide.querySelector('img');
      if (img) images.push({ src: img.src, srcset: img.srcset || '', alt: img.alt });
    });

    if (count === 1) {
      setupLightbox();
      return;
    }

    var slideWidth = 0;
    var totalWidth = 0;
    var offset = 0;
    var pos = 0;
    var current = 0;
    var isPaused = false;
    var isDragging = false;
    var hasDragged = false;
    var isAnimating = false;
    var dragStartX = 0;
    var dragStartPos = 0;
    var timer = null;
    var DRAG_THRESHOLD = 5;
    var ANIM_MS = 600;
    var PAUSE_MS = 3000;

    function updateActive() {
      var allSlides = track.querySelectorAll('[data-gallery-slide]');
      var gw = galleryWidth();
      allSlides.forEach(function(slide) {
        var rect = slide.getBoundingClientRect();
        var center = rect.left + rect.width / 2;
        var active = Math.abs(center - gw / 2) < rect.width * 0.4;
        if (active) {
          slide.classList.add('is-active');
        } else {
          slide.classList.remove('is-active');
        }
      });
    }

    function galleryWidth() {
      return gallery.getBoundingClientRect().width;
    }

    function measure() {
      slideWidth = originals[0].getBoundingClientRect().width;
      totalWidth = slideWidth * count;
      offset = totalWidth;
    }

    function centerFor(index) {
      var i = ((index % count) + count) % count;
      return offset + i * slideWidth + slideWidth / 2 - galleryWidth() / 2;
    }

    function nearestIndex() {
      var viewportCenter = -pos + galleryWidth() / 2;
      var rel = viewportCenter - offset;
      var idx = Math.round((rel - slideWidth / 2) / slideWidth);
      return ((idx % count) + count) % count;
    }

    function setPos(p) {
      pos = p;
      track.style.transform = 'translateX(' + (-pos) + 'px)';
      updateActive();
    }

    function normalize() {
      var d = pos - offset;
      d = ((d % totalWidth) + totalWidth) % totalWidth;
      setPos(offset + d);
    }

    function animateTo(target, ms) {
      if (isAnimating) return;
      isAnimating = true;
      track.style.transition = 'transform ' + ms + 'ms cubic-bezier(0.25, 0.1, 0.25, 1)';
      setPos(target);
      setTimeout(function() {
        track.style.transition = '';
        normalize();
        isAnimating = false;
        if (autoplay && !isPaused) scheduleNext();
      }, ms + 20);
    }

    function goTo(index, direction) {
      clearTimeout(timer);
      var i = ((index % count) + count) % count;
      var target;
      if (direction !== undefined) {
        target = pos + direction * slideWidth;
      } else {
        target = centerFor(i);
      }
      current = i;
      animateTo(target, ANIM_MS);
    }

    function advance() {
      if (isPaused || isDragging || isAnimating) return;
      current = (current + 1) % count;
      goTo(current, 1);
    }

    function scheduleNext() {
      clearTimeout(timer);
      timer = setTimeout(advance, PAUSE_MS);
    }

    function init() {
      measure();
      setPos(centerFor(0));
      track.classList.add('is-ready');
      if (autoplay) scheduleNext();
    }

    function setupLightbox() {
      if (!enableZoom || !lightbox || images.length === 0) return;

      var lightboxImage = lightbox.querySelector('[data-lightbox-image]');
      var lightboxCurrent = lightbox.querySelector('[data-lightbox-current]');
      var lightboxTotal = lightbox.querySelector('[data-lightbox-total]');
      var lbIndex = 0;

      if (lightboxTotal) lightboxTotal.textContent = images.length;

      function openLightbox(index) {
        lbIndex = index;
        updateLightbox();
        lightbox.classList.add('is-open');
        lightbox.setAttribute('aria-hidden', 'false');
        document.body.style.overflow = 'hidden';
      }

      function closeLightbox() {
        lightbox.classList.remove('is-open');
        lightbox.setAttribute('aria-hidden', 'true');
        document.body.style.overflow = '';
      }

      function updateLightbox() {
        var img = images[lbIndex];
        if (!img) return;
        lightboxImage.src = img.src;
        lightboxImage.srcset = img.srcset;
        lightboxImage.alt = img.alt;
        if (lightboxCurrent) lightboxCurrent.textContent = lbIndex + 1;
      }

      track.addEventListener('click', function(e) {
        if (hasDragged) return;
        var slide = e.target.closest('[data-gallery-slide]');
        if (!slide) return;
        var allSlides = track.querySelectorAll('[data-gallery-slide]');
        var idx = -1;
        for (var i = 0; i < allSlides.length; i++) {
          if (allSlides[i] === slide) { idx = i % count; break; }
        }
        if (idx < 0) idx = 0;
        openLightbox(idx);
      });

      lightbox.querySelector('[data-lightbox-close]').addEventListener('click', closeLightbox);
      lightbox.querySelector('[data-lightbox-next]').addEventListener('click', function() {
        lbIndex = (lbIndex + 1) % images.length;
        updateLightbox();
      });
      lightbox.querySelector('[data-lightbox-prev]').addEventListener('click', function() {
        lbIndex = (lbIndex - 1 + images.length) % images.length;
        updateLightbox();
      });
      lightbox.addEventListener('click', function(e) {
        if (e.target === lightbox) closeLightbox();
      });
      document.addEventListener('keydown', function(e) {
        if (!lightbox.classList.contains('is-open')) return;
        if (e.key === 'Escape') closeLightbox();
        if (e.key === 'ArrowRight') { lbIndex = (lbIndex + 1) % images.length; updateLightbox(); }
        if (e.key === 'ArrowLeft') { lbIndex = (lbIndex - 1 + images.length) % images.length; updateLightbox(); }
      });
    }

    var initialized = false;
    var originalImgs = track.querySelectorAll('[data-gallery-slide]:not([data-gallery-clone]) img');
    var loaded = 0;
    var imgTotal = originalImgs.length;

    function onReady() {
      loaded++;
      if (loaded >= imgTotal && !initialized) {
        initialized = true;
        init();
      }
    }

    if (imgTotal === 0) {
      initialized = true;
      init();
    } else {
      originalImgs.forEach(function(img) {
        if (img.complete && img.naturalWidth > 0) {
          onReady();
        } else {
          img.addEventListener('load', onReady);
          img.addEventListener('error', onReady);
        }
      });
      setTimeout(function() {
        if (!initialized) { initialized = true; init(); }
      }, 500);
    }

    gallery.addEventListener('mouseenter', function() { isPaused = true; clearTimeout(timer); });
    gallery.addEventListener('mouseleave', function() { isPaused = false; if (autoplay && !isAnimating) scheduleNext(); });

    track.addEventListener('pointerdown', function(e) {
      if (isAnimating) return;
      isDragging = true;
      hasDragged = false;
      dragStartX = e.clientX;
      dragStartPos = pos;
      track.setPointerCapture(e.pointerId);
      gallery.style.cursor = 'grabbing';
    });

    track.addEventListener('pointermove', function(e) {
      if (!isDragging) return;
      var diff = dragStartX - e.clientX;
      if (Math.abs(diff) > DRAG_THRESHOLD) hasDragged = true;
      setPos(dragStartPos + diff);
    });

    track.addEventListener('pointerup', function(e) {
      if (!isDragging) return;
      isDragging = false;
      gallery.style.cursor = 'grab';
      var dragDelta = dragStartX - e.clientX;
      if (Math.abs(dragDelta) < DRAG_THRESHOLD) {
        normalize();
        setPos(centerFor(current));
        return;
      }
      var direction = dragDelta > 0 ? 1 : -1;
      current = (current + direction + count) % count;
      var target = dragStartPos + direction * slideWidth;
      track.style.transition = 'transform 300ms ease';
      setPos(target);
      setTimeout(function() {
        track.style.transition = '';
        normalize();
      }, 320);
    });

    track.addEventListener('pointercancel', function() {
      isDragging = false;
      gallery.style.cursor = 'grab';
      normalize();
    });

    if (prevBtn) {
      prevBtn.addEventListener('click', function() {
        current = ((current - 1) + count) % count;
        goTo(current, -1);
      });
    }

    if (nextBtn) {
      nextBtn.addEventListener('click', function() {
        current = (current + 1) % count;
        goTo(current, 1);
      });
    }

    setupLightbox();

    var resizeTimer;
    window.addEventListener('resize', function() {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(function() {
        if (!initialized) return;
        measure();
        setPos(centerFor(current));
      }, 150);
    });

    if (typeof ResizeObserver !== 'undefined') {
      new ResizeObserver(function() {
        if (!initialized) return;
        measure();
        setPos(centerFor(current));
      }).observe(gallery);
    }

    track.addEventListener('contextmenu', function(e) {
      if (isDragging) e.preventDefault();
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["search-result-card"] && !Shopify.designMode) return;
  try {
    document.querySelectorAll('.search-result-card__form').forEach(form => {
    form.addEventListener('submit', async (e) => {
      e.preventDefault();
      
      const button = form.querySelector('[data-add-to-cart]');
      const formData = new FormData(form);
      const cartType = window.CartUtils ? window.CartUtils.getCartType() : 'page';
      
      button.classList.add('is-adding');
      button.disabled = true;
      
      try {
        const result = await window.CartUtils.addItem(formData);
        
        if (result.success) {
          button.classList.remove('is-adding');
          button.classList.add('is-added');
          
          if (cartType === 'page') {
            window.location = '/cart';
          }
          
          setTimeout(() => {
            button.classList.remove('is-added');
            button.disabled = false;
          }, 2000);
        } else {
          throw new Error(result.error || 'Failed to add to cart');
        }
      } catch (error) {
        console.error('Error adding to cart:', error);
        button.classList.remove('is-adding');
        button.disabled = false;
      }
    });
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["share-buttons"] && !Shopify.designMode) return;
  try {
    document.querySelectorAll('[data-share-buttons]').forEach(container => {
    const statusEl = container.querySelector('[data-share-status]')
    const copyButton = container.querySelector('[data-copy-link]')
    
    if (copyButton) {
      copyButton.addEventListener('click', async () => {
        const url = copyButton.dataset.copyLink
        
        try {
          await navigator.clipboard.writeText(url)
          copyButton.classList.add('is-copied')
          
          if (statusEl) {
            statusEl.textContent = copyButton.querySelector('[data-copied-message]')?.textContent || 'Link copied'
          }
          
          setTimeout(() => {
            copyButton.classList.remove('is-copied')
            if (statusEl) statusEl.textContent = ''
          }, 2000)
        } catch (err) {
          console.error('Failed to copy:', err)
          if (statusEl) statusEl.textContent = 'Failed to copy link'
        }
      })
    }
  })
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["sticky-atc"] && !Shopify.designMode) return;
  try {
    class StickyATC {
    constructor(container) {
      this.container = container
      this.triggerElement = document.querySelector('[data-product-form]') || document.querySelector('.product-info')
      this.addToCartText = container.dataset.addToCartText
      this.soldOutText = container.dataset.soldOutText
      this.loadingText = container.dataset.loadingText
      this.errorText = container.dataset.errorText
      this.locale = container.dataset.locale || 'en-GB'
      this.currency = container.dataset.currency || 'GBP'
      
      if (this.triggerElement) {
        this.init()
      }
    }

    init() {
      const observer = new IntersectionObserver(
        (entries) => {
          entries.forEach(entry => {
            this.container.classList.toggle('is-visible', !entry.isIntersecting)
          })
        },
        { threshold: 0, rootMargin: '-100px 0px 0px 0px' }
      )
      
      observer.observe(this.triggerElement)
      
      document.addEventListener('variant:change', (e) => {
        this.updateVariant(e.detail.variant)
      })

      const form = this.container.querySelector('.sticky-atc__form')
      if (form) {
        form.addEventListener('submit', (e) => this.handleSubmit(e))
      }
    }

    async handleSubmit(e) {
      e.preventDefault()
      
      const form = e.target
      const button = form.querySelector('.sticky-atc__button')
      const formData = new FormData(form)
      const cartType = window.CartUtils ? window.CartUtils.getCartType() : 'page'

      button.disabled = true
        button.textContent = this.loadingText

      try {
        const result = await window.CartUtils.addItem(formData)
        
        if (result.success) {
          button.textContent = this.addToCartText
          button.disabled = false
          
          if (cartType === 'page') {
            window.location = '/cart'
          }
        } else {
         throw new Error(result.error || this.errorText)
          button.textContent = this.errorText
          button.disabled = false
        }
      } catch (error) {
        console.error('Error adding to cart:', error)
        button.textContent = this.addToCartText
        button.disabled = false
      }
    }

    updateVariant(variant) {
      if (!variant) return
      
      const priceEl = this.container.querySelector('[data-sticky-price]')
      const variantInput = this.container.querySelector('[data-sticky-variant-id]')
      const button = this.container.querySelector('.sticky-atc__button')
      
      if (priceEl) {
        priceEl.textContent = variant.available 
          ? this.formatMoney(variant.price)
          : this.soldOutText
      }
      
      if (variantInput) {
        variantInput.value = variant.id
      }
      
      if (button) {
        button.disabled = !variant.available
        button.textContent = variant.available 
          ? this.addToCartText
          : this.soldOutText
        button.classList.toggle('sticky-atc__button--disabled', !variant.available)
      }
    }

    formatMoney(cents) {
      return new Intl.NumberFormat(this.locale, {
        style: 'currency',
        currency: this.currency
      }).format(cents / 100)
    }
  }

  const stickyATC = document.querySelector('[data-sticky-atc]')
  if (stickyATC) {
    new StickyATC(stickyATC)
  }
  } catch(e) { console.error(e); }
})();

})();
